import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import {
  UserDailyFirstAccessLog,
  userDailyFirstAccessLogSearchParams,
} from '../../types/resources/UserDailyFirstAccessLogType';

const endpoint = '/partner_admins/user_daily_first_access_logs';

type GetResponseType = {
  data: {
    user_daily_first_access_logs: UserDailyFirstAccessLog[];
  };
  headers: Record<string, string>;
};

export async function getUserDailyFirstAccessLogs(
  signOut?: () => void,
  searchParams?: userDailyFirstAccessLogSearchParams
): Promise<GetResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `${endpoint}${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function getUserDailyFirstAccessLogsCSV(
  signOut?: () => void
): Promise<{ data: Blob }> {
  const response = await partnerAdminFetch(
    `${endpoint}.csv`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.blob();

  return { data };
}
